<div class="ui-g customer-list">

  <div class="ui-g-12 ui-lg-6">
    <h1>{{'customers.auth_title' | translate}}</h1>
  </div>

  <div class="ui-g-12">

    <app-kontable #table data-testid="table" *ngIf="customerAuthPermissions && !showDetails"
                  title = "{{ 'common.customers_auth' | translate }}"
                  [columns] = "[
                    { field: 'flgCompany', bodyTemplate: isCompanyTemplate, filterTemplate: isCompanyFilter, filterType: customFilter, title: 'customerInfoSheet.type' },
                    { field: 'id', title: '#', filterType: numberFilter },
                    { field: 'flg_state', title: 'common.status', bodyTemplate: stateTemplate, filterType: customFilter, filterTemplate: stateFilter },
                    { field: 'account_type_description', title: 'customers.auth_admin_account_type'},
                    'user_account',
                    { field: 'host_id', title: 'common.code'},
                    'surname',
                    'name',
                    { field: 'ts_ins', title: 'common.ts_ins' },
                    { field: 'customerCardState', title: 'common.status_link', bodyTemplate: cardStateTemplate, filterType: selectFilter, filterOptions: {values: cardStates}},
                    'card_no',
                    { field: 'insegna', title: 'stores.insegna', filterType: selectFilter, filterOptions: {values: listSourceSystem}}
                  ]"
                  [titles] = "[ 'customers.auth_user_account', 'customers.auth_surname', 'customers.auth_name', 'customers.auth_card_no' ]"
                  [showDetailsButton]="false"
                  [showInfoButton]="false"
                  [showEditButton]="false"
                  [(fireNewDataAvailable)]="newDataAvailable"
                  [paginationType]="paginationType"
                  [service]="svcCustomersAdmin"
                  [servicePermissions]="customerAuthPermissions"
                  [showDownloadExcelBtn]="customerExportExcelPermission"
                  [additionalRowCommands]="customActions"
                  (onRemove)="deleteCustomerAuth($event)"
                  (onRecover)="recoverCustomerAuth($event)"
                  (onDownloadExcel)="downloadExcel($event)"
                  [filterBySingleColumn]="!staticTable"
                  [showExtSearch]="true"
                  [extSearchConfigKey]="'extsearch-custadmin'"
                  (extSearchReq)="sendExtSearchQuery($event)"
                  [extSearchResult]="extSearchResult"
                  [totalRecords]="totalRecords">

      <ng-template #isCompanyTemplate data-testid="isCompanyTemplate" let-row>
        <span *ngIf="row.flgCompany === 'S'" class="fa fa-building" title="company"></span>
        <span *ngIf="row.flgCompany === 'N'" class="fa fa-user" title="customer"></span>
      </ng-template>

      <ng-template #isCompanyFilter data-testid="isCompanyFilter" let-col>
        <p-dropdown [options]="listTypeCompany" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
      </ng-template>

      <ng-template let-row #stateTemplate>
        <span>{{ ('customers.auth_' + evaluateFlag(row['flg_state'])) | translate }}</span>
      </ng-template>

      <ng-template let-row #cardStateTemplate>
        <span>{{ (evaluateState(row['customerCardState'])) | translate }}</span>
      </ng-template>

      <ng-template #stateFilter data-testid="stateFilter" let-col>
        <p-dropdown [options]="flagItems" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
      </ng-template>

      <ng-template #dateTemplateIns data-testid="dateTemplateIns" let-row>
        {{ row['ts_ins'] | date: 'yyyy-MM-dd' }}
      </ng-template>

      <ng-template #dateTemplateUpd data-testid="dateTemplateUpd" let-row>
        {{ row['ts_upd'] | date: 'yyyy-MM-dd' }}
      </ng-template>

      <ng-template #customActions data-testid="customActions" let-row>
        <p-button pTooltip="{{ 'common.edit' | translate }}" icon="fa fas fa-edit" *ngIf="row['flg_state'] != '1' && (row['account_type_host_id'] == 'M' || row['account_type_host_id'] == 'T' || row['account_type_host_id'] == 'E') " styleClass="ui-button-info" (onClick)="editCustomerAuth(row)"></p-button>
        <p-button *ngIf="row['flg_state']=='0' || row['flg_state']=='7'" pTooltip="{{ 'common.reset' | translate }}" icon="fa fas fa-bolt"  styleClass="ui-button-info" (onClick)="onResetAuth(row)"></p-button>
        <p-button pTooltip="{{ 'customers.title' | translate }}" icon="fa fas fa-user"  styleClass="ui-button-info" (onClick)="onClickCustomer(row['flgCompany'], row['customerHostId'], row['customerId'])"></p-button>
        <p-button *ngIf="row['flg_state']=='3'" pTooltip="{{ 'customers.auth_resend_activate' | translate }}" icon="fa fas fa-share-square-o"  styleClass="ui-button-info" (onClick)="onResendActivation(row)"></p-button>
        <p-button *ngIf="(row['flg_state']=='2' && row['social']==false) && showResetPermission" pTooltip="{{ 'customers.auth_reset' | translate }}" icon="fa fa-key"  styleClass="ui-button-info" (onClick)="openResetPassword(row)"></p-button>
        <p-button *ngIf="user.role == 'S' && row['flg_state']=='0'" pTooltip="{{ 'common.generateCustomerAuthToken' | translate }}" icon="fa fa-cog"  styleClass="ui-button-info" (onClick)="openGenerateCustomerAuth(row)"></p-button>
      </ng-template>

    </app-kontable>

    <kv-customers-auth-admin-form
      *ngIf="showDetails && detailsData"
      [customerAuthData]="this.detailsData"
      (onBack)="showDetails = false; detailsData = null"
    ></kv-customers-auth-admin-form>

    <p-dialog
        *ngIf="showDialog"
        [(visible)]="showDialog"
        [modal]="true"
        header="{{ 'customers.auth_reset' | translate }}"
        [minWidth]="500"
        [draggable]="false"
        [resizable]="false"
        (onHide)="closeDialog()">
      <app-customers-auth-form
        [data] = "currentRow"
        [companyCode] = "companyCode"
        (esito) = "resetPwdAction($event)" >
      </app-customers-auth-form>
    </p-dialog>

    <p-dialog
      *ngIf="showGenerateModal"
      [(visible)]="showGenerateModal"
      [modal]="true"
      [minWidth]="700"
      [draggable]="false"
      [resizable]="false"
      (onHide)="closeDialog()">

      <div class="ui-grid ui-grid-responsive ui-fluid" >
        <div class="ui-grid-row">
          <div class="ui-grid-col-4">
            <label>{{ 'common.newToken' | translate }}</label>
          </div>
          <div class="ui-grid-col-8">
            <input type="text" pInputText [(ngModel)]="customerAuthToken"/>
          </div>
        </div>
      </div>

    </p-dialog>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/admin/customers-auth-admin.component.html